import { CheckCircleIcon } from '@heroicons/react/24/outline'
import { Alert, Button, Label, Modal } from 'flowbite-react'

interface IConfirmarPedidoModalProps {
  onClose: () => void
  isOpen: boolean
  isPedidoComboleto?: boolean
}

const ConfirmarPedidoModal: React.FC<IConfirmarPedidoModalProps> = ({
  onClose,
  isOpen
}: IConfirmarPedidoModalProps) => {
  return (
    <>
      <Modal
        show={isOpen}
        onClose={onClose}
        size='xl'
      >
        <Modal.Body>
          <div className='mb-5 text-center'>
            <Alert color={'success'} className='flex items-center'>
              <div className='flex flex-col justify-center items-center gap-2 mb-4'>
                <CheckCircleIcon className='md:w-8 md:h-8 w-12 h-12 text-green-500' />
                <span className='block text-center text-2xl font-semibold'>
                  Pedido criado.
                </span>
                <Label className='block mt-4 text-gray-600 leading-7 text-center'>
                  Na próxima tela, aguarde o status <strong>Processado</strong>. <br />
                  Clique nos três pontinhos e selecione “Aprovar”.
                </Label>
              </div>
            </Alert>
          </div>
          <div className='flex gap-2 justify-center items-center'>
            <Button color='gray' onClick={onClose} data-testid='btn-close'>
              Fechar
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default ConfirmarPedidoModal
